import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';

interface IState {}

interface Props {
  model: any;
}

export default class ShopNameItemView extends React.Component<Props, IState> {
  getShopNameContent = () => {
    const data = this.props.model.originalData;
    if (!data) return [];
    const pickUpIcon = this.getShopNameIcon(data);
    const content: any[] = [];
    // 间隔
    const placeholder = {
      type: 'placeholder',
      width: 4
    };
    const lineHeight = 21; // 行高：粗体行高较高
    // 自提标签
    if (pickUpIcon && pickUpIcon.picUrl) {
      content.push({
        type: 'image',
        src: pickUpIcon.picUrl,
        width: pickUpIcon.width || 0,
        height: pickUpIcon.height || 0,
        verticalOffset: Math.floor(pickUpIcon.height - lineHeight) * 0.5,
        verticalAlignment: 'center'
      });
      content.push(placeholder);
    }
    // 店铺名称
    if (data.name) {
      content.push({
        type: 'text',
        text: data.name,
        backgroundColor: 'clear',
        color: '#222222',
        fontFamily: 'KeeTa-Bold',
        fontSize: 16,
        fontWeight: 700,
      });
    }
    return content;
  }

  /**
   * 获取店铺名称前缀标签
   */
  getShopNameIcon = (data) => {
    if (!data) {
      return null;
    }
    let pickUpIcon = data.pickUpIcon;
    if (data?.shopStatus?.shopStatusCode === 4) {
      pickUpIcon = data.shopStatus?.shopStatusPic; // 休息中
    }
    return pickUpIcon;
  }

  render() {
    const { model } = this.props;
    return (
      <view className="container">
        <RichText className="shopName" content={this.getShopNameContent()} />
      </view>
    );
  }
}
